import React from 'react';
import { t } from 'ttag';
import { VariablesData } from '../..';
import Slide, { ISlide } from '../../../../core/Slide';
import { CharacterDialogue } from '../../../../general/Character';
import { DialogueData } from '../../../../general/Dialogue';
import useFooterButtonRenderer from '../../../../misc/FooterButtonRenderer';
import { FlubFlub, GlibGlob } from '../../characters/Aliens';

const MissionOutro: React.FC<ISlide<VariablesData>> = ({ defaultHeader, nextSlide, data }) => {
    const [footer, buttonRenderer] = useFooterButtonRenderer();

    const dialogue: DialogueData[] = [
        {
            character: FlubFlub,
            text: t`Wow! I haven’t seen a beginner blast asteroids like that before!`,
            buttonText: t`Thanks!`,
        },
        {
            character: GlibGlob,
            text: t`You are right... We are going to start assigning you to some more important missions ${data.name}. You seem to be finding this too easy.`,
            buttonText: t`Next`,
            buttonAction: nextSlide,
        },
    ];

    return (
        <Slide header={defaultHeader} footer={footer}>
            <CharacterDialogue dialogue={dialogue} buttonHandler={buttonRenderer} />
        </Slide>
    );
};

export default MissionOutro;
